
const mobileAgents = ["Android", "iPhone", "iPad", "iPod", "Symbian"];
let userAgent = navigator.userAgent;

export const Common = {
	isMobile: mobileAgents.some(ag => userAgent.includes(ag)),

	toDiscord() {
		window.location.href = "";
	},
	toTwitter() {
		window.location.href = "";
	}
}
